import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { LightMode, DarkMode } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useThemeMode } from '../contexts/ThemeProvider';

const ThemeToggle: React.FC = () => {
  const { mode, toggleColorMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
  <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
  <IconButton
    onClick={toggleColorMode}
    component={motion.div}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    sx={{
      position: 'absolute',
      top: { xs: 20, md: 30 },
      right: { xs: 20, md: 30 },
      zIndex: 1000,
     
     
      borderRadius: 3,
      background: isDark
        ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.08))'
        : 'linear-gradient(145deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.02))',
      backdropFilter: 'blur(15px)',
      border: isDark
        ? '1px solid rgba(255, 255, 255, 0.15)'
        : '1px solid rgba(0, 0, 0, 0.1)',
      color: isDark ? 'white' : 'black',
      boxShadow: isDark
        ? '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
        : '0 4px 20px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
      '&:hover': {
        background: isDark
          ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.12))'
          : 'linear-gradient(145deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.04))',
        transform: 'translateY(-1px)',
      },
      '&:active': {
        background: isDark
          ? 'linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.15))'
          : 'linear-gradient(145deg, rgba(0, 0, 0, 0.07), rgba(0, 0, 0, 0.1))',
        transform: 'translateY(0px)',
      },
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    }}
  >
    <motion.div
      initial={false}
      animate={{ rotate: isDark ? 180 : 0 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isDark ? <LightMode fontSize="small" /> : <DarkMode fontSize="small" />}
    </motion.div>
  </IconButton>
</Tooltip>

  );
};

export default ThemeToggle;